import { IconDefinition } from "./types";

const shield: IconDefinition = {
  iconName: "shield",
  width: 512,
  height: 512,
  svgPathData:
    "M256 51.5L64.1 126c-1 43.5 6.9 106.9 33.8 168.8 28.2 64.9 77 127.7 158.1 164.8 81.1-37.1 129.9-99.9 158.1-164.8 26.9-61.9 34.8-125.3 33.8-168.8L256 51.5zm238.3 41l1.2 20.5c2.9 50-4.9 126.3-37.3 200.9-32.7 75.2-91.1 150-189.4 192.6l-12.7 5.5-12.7-5.5C144.9 463.9 86.6 389.2 53.9 313.9 21.5 239.3 13.7 162.9 16.6 113L17.8 92.5 37 85 244.5 4.5 256 0 267.6 4.5 475.1 85 494.3 92.5z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "shield",
  unicode: 0xf132,
};

export { shield };
